import { render } from "./GameRulesAndar.vue?vue&type=template&id=7720b9ea&scoped=true"
import script from "./GameRulesAndar.vue?vue&type=script&lang=js"
export * from "./GameRulesAndar.vue?vue&type=script&lang=js"

import "./GameRulesAndar.vue?vue&type=style&index=0&id=7720b9ea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7720b9ea"]])

export default __exports__